import { DataType } from "../../../enums/dataType";
import { FieldType } from "../../../enums/fieldType";
import { FieldDto } from "./fieldDto";

class SortCodeFieldDto extends FieldDto {

    public fieldType: FieldType = FieldType.SortCode;

    public dataType: DataType = DataType.SortCode;
}

export { SortCodeFieldDto };